import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AdditionalBookingChargeValidation } from 'uplisting-frontend/validations';

export default class AdditionalBookingChargeRepositoryService extends BaseRepositoryService<
  ModelRegistry['additional-booking-charge']
> {
  recordName = 'additional-booking-charge';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = AdditionalBookingChargeValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/additional-booking-charge': AdditionalBookingChargeRepositoryService;
  }
}
